<template>

     <v-footer app absolute class=" footerClass"  height="auto">
       <hr />

       <v-layout row wrap align-content-end class="border pl-2 pr-2">
         <v-flex class="xs6 text-xs-left">
           <span class="link">
             <v-icon>{{$vuetify.icons.email}}</v-icon>
             <a href="mailto:dan@smartkidsmarket.com">
               Contact SmartKidsMarket
             </a>
           </span>
           <br />
           <v-btn small flat :to="{'name': 'Acknowledgements'}">Acknowledgements</v-btn>
         </v-flex>
         <v-flex  hidden-xs-only class="xs6 text-xs-right">
             <router-link :to="{ name: 'Privacy', params: {} }">Privacy Policy</router-link> |
             <router-link :to="{ name: 'TermsOfService', params: {} }">Terms of Service</router-link> |
             <router-link :to="{ name: 'CookiePolicy', params: {} }">Cookie Policy</router-link>
         </v-flex>
         <v-flex hidden-sm-and-up class="xs6 text-xs-right">
             <router-link :to="{ name: 'Privacy', params: {} }">Privacy</router-link> |
             <router-link :to="{ name: 'TermsOfService', params: {} }">Terms</router-link> |
             <router-link :to="{ name: 'CookiePolicy', params: {} }">Cookie</router-link>
         </v-flex>
         <v-flex class="xs12">
           <span>&copy; Smart Kids Market, LLC {{ new Date().getFullYear() }}</span>
         </v-flex>
       </v-layout>

     </v-footer>

</template>

<script>
// import firebase from 'firebase/app'
// import {mapState} from 'vuex'

export default {
  name: 'Footer',
  components: {
  },
  data () {
    return {

    }
  },
  mounted: function () {
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.breakout {
  margin:1em -100%; /* old browsers fallback */
  margin:1em calc(50% - 50vw);
}

.footerClass {
  background-color:rgba(255,255,255,0.5);
  padding: 0

  /* position:absolute;
  bottom:0;
  width:100%;
  height:80px;   /* Height of the footer */ */
}

</style>
